import { WHATSAPP_TEMPLATES_PAGE_KEY } from './constants';

export const es = {
  [WHATSAPP_TEMPLATES_PAGE_KEY]: {
    TABLE_TITLE: 'Plantillas',
    IMPORT_TEMPLATE_BUTTON: 'Importar plantilla',

    PAGE_DESCRIPTION:
      'Las plantillas se crean y se aprueban en WhatsApp Manager. Aquí las importas y eliges el dato de Crehana que llena cada variable.',
    MANAGER_LINK: 'Abrir WhatsApp Manager',
    MANAGER_LINK_NEW_TAB: '(se abre en una pestaña nueva)',

    COLUMN_TEMPLATE: 'Plantilla',
    COLUMN_IN_WHATSAPP: 'En WhatsApp',
    COLUMN_META_STATUS: 'Estado',
    COLUMN_CATEGORY: 'Categoría',
    COLUMN_VARIABLES: 'Variables',
    COLUMN_ACTIONS: 'Acciones',

    PRODUCT_SELECTOR_LABEL: 'Producto',
    PRODUCT_UNAVAILABLE_TAG: 'Próximamente',
    PRODUCT_RECRUITMENT: 'Reclutamiento',
    PRODUCT_ENGAGEMENT: 'Clima',
    PRODUCT_LEARNING: 'Aprendizaje',
    PRODUCT_PAYROLL: 'Nómina',
    PRODUCT_PERFORMANCE: 'Desempeño',
    PRODUCT_PERSONAS_HRIS: 'Gestión',

    SEARCH_PLACEHOLDER: 'Buscar por alias o nombre en WhatsApp',
    FILTER_META_STATUS_LABEL: 'Estado',
    FILTER_META_STATUS_ALL_OPTION: 'Todos',
    FILTER_META_STATUS_CLEAR: 'Quitar el filtro de estado',
    FILTER_INCOMPLETE_LABEL: 'Variables sin dato',
    FILTER_CHIP_STATUS: 'Estado: {{status}}',
    FILTER_CHIP_REMOVE: 'Quitar filtro {{filter}}',
    FILTER_CLEAR_ALL: 'Limpiar todo',
    PAGE_SIZE_LABEL: 'Filas por página',
    SORT_BY: 'Ordenar por {{column}}',
    SORT_ASCENDING: 'Orden ascendente',
    SORT_DESCENDING: 'Orden descendente',
    PAGINATION_LABEL: 'Paginación',
    PAGINATION_PREVIOUS: 'Página anterior',
    PAGINATION_NEXT: 'Página siguiente',
    PAGINATION_PAGE: 'Página {{page}}',
    PAGINATION_PAGE_OF: 'Página {{page}} de {{total}}',
    PAGINATION_OF_TOTAL: 'de {{total}}',

    NO_RESULTS_TITLE: 'Ninguna plantilla coincide',
    NO_RESULTS_DESCRIPTION: 'Prueba otra búsqueda o quita un filtro.',
    NO_RESULTS_CLEAR: 'Limpiar filtros',

    LAST_SYNC_LABEL: 'Última sincronización: {{date}}',
    LAST_SYNC_NEVER: 'Última sincronización: sin datos',
    SYNC_ACTION_LABEL: 'Sincronizar con WhatsApp',
    SYNC_ACTION_TOOLTIP: 'Sincronizar con WhatsApp. Última vez: {{date}}',
    SYNC_ACTION_SYNCING_LABEL: 'Sincronizando...',
    SYNC_TOAST_TITLE: 'Plantillas sincronizadas con WhatsApp',
    SYNC_TOAST_DESCRIPTION:
      '{{updated}} actualizadas · {{unchanged}} sin cambios · {{missing}} ya no están en WhatsApp · {{outdated}} con el mapeo desactualizado',
    SYNC_ERROR_TITLE: 'No se pudo sincronizar con WhatsApp',
    SYNC_ERROR_META_NOT_CONFIGURED:
      'Este entorno no tiene configurada la conexión con WhatsApp.',
    SYNC_ERROR_META_ACCESS_DENIED:
      'WhatsApp rechazó el acceso de Crehana a sus plantillas.',
    SYNC_ERROR_META_UNAVAILABLE:
      'WhatsApp no respondió. Vuelve a intentarlo en unos minutos.',
    SYNC_ERROR_GENERIC: 'Vuelve a intentarlo.',
    SYNC_RESULT_TITLE: 'Revisa estas plantillas',
    SYNC_RESULT_MISSING: 'Ya no están en WhatsApp: {{slugs}}',
    SYNC_RESULT_OUTDATED:
      'Su mensaje cambió en WhatsApp. Edita su mapeo antes del próximo envío: {{slugs}}',

    VARIABLES_COUNT: '{{mapped}} de {{total}} con dato',
    VARIABLES_NONE: 'Sin variables',

    ROW_MENU_TRIGGER_LABEL: 'Acciones de {{alias}}',
    ROW_MENU_VIEW: 'Ver detalle',
    ROW_MENU_EDIT: 'Editar datos de variables',
    ROW_MENU_REMOVE: 'Eliminar de Crehana',

    DETAIL_COPY_SLUG: 'Copiar slug',
    DETAIL_SLUG_COPIED: 'Slug copiado',
    DETAIL_MORE_ACTIONS: 'Más acciones',
    DETAIL_CLOSE: 'Cerrar',
    DETAIL_MESSAGE_TITLE: 'Mensaje',
    DETAIL_MESSAGE_VIEW_LABEL: 'Cómo mostrar las variables',
    DETAIL_MESSAGE_WITH_EXAMPLES: 'Con ejemplos',
    DETAIL_MESSAGE_WITH_VARIABLES: 'Con variables',
    DETAIL_MESSAGE_NOTE: 'Vista aproximada. WhatsApp aplica su propio formato.',
    DETAIL_MESSAGE_PENDING_TITLE:
      'WhatsApp aún no envía el texto de esta plantilla',
    DETAIL_MESSAGE_PENDING_DESCRIPTION:
      'El texto y sus variables llegan cuando Meta aprueba la plantilla. Después, sincroniza.',
    DETAIL_SYNC_NOW: 'Sincronizar ahora',
    DETAIL_VARIABLES_TITLE: 'Dato de cada variable',
    DETAIL_VARIABLE_NO_DATUM: 'Sin dato',
    DETAIL_VARIABLE_ASSIGN: 'Asignar',
    DETAIL_VARIABLE_EXAMPLE: 'Ej.: {{example}}',
    DETAIL_VARIABLES_BLOCKED:
      'Crehana no puede enviar esta plantilla hasta que cada variable tenga un dato.',
    DETAIL_VARIABLES_NONE: 'El mensaje no tiene variables.',
    DETAIL_META_TITLE: 'Datos de WhatsApp',
    DETAIL_META_NAME: 'Nombre en WhatsApp',
    DETAIL_META_LANGUAGE: 'Idioma',
    DETAIL_META_CATEGORY: 'Categoría',
    DETAIL_META_ID: 'ID de WhatsApp',
    DETAIL_META_LAST_SYNC: 'Última sincronización',
    DETAIL_META_NOTE:
      'Solo lectura. Para cambiarlos, edita la plantilla en WhatsApp Manager y sincroniza.',
    DETAIL_ASSIGN_DATA: 'Asignar datos',

    REMOVE_DIALOG_TITLE: 'Quitar del registro',
    REMOVE_DIALOG_DESCRIPTION:
      'La plantilla sigue en WhatsApp. Solo se quita del registro de Crehana.',
    REMOVE_DIALOG_DETAIL:
      '«{{alias}}» ({{slug}}) sale del registro y ya no se puede enviar. En WhatsApp no cambia nada.',
    REMOVE_DIALOG_USED_BY_PRODUCT: 'La usa el producto {{product}}.',
    REMOVE_DIALOG_CONFIRM: 'Quitar',
    REMOVE_DIALOG_CANCEL: 'Cancelar',
    REMOVE_TOAST_DONE: 'Plantilla quitada del registro. Slug: {{slug}}',
    REMOVE_TOAST_ERROR: 'No se pudo quitar la plantilla',
    REMOVE_TOAST_ERROR_DESCRIPTION: 'Vuelve a intentarlo.',

    EMPTY_STATE_TITLE: '{{product}} aún no tiene plantillas',
    EMPTY_STATE_DESCRIPTION:
      'Importa una plantilla aprobada en WhatsApp Manager para usarla desde Crehana.',

    ERROR_STATE_TITLE: 'No pudimos cargar las plantillas',
    ERROR_STATE_DESCRIPTION: 'Revisa tu conexión y vuelve a intentarlo.',
    ERROR_STATE_RETRY: 'Reintentar',

    META_STATUS_APPROVED: 'Aprobada',
    META_STATUS_PENDING: 'En revisión',
    META_STATUS_REJECTED: 'Rechazada',
    META_STATUS_PAUSED: 'Pausada',

    CATEGORY_MARKETING: 'Marketing',
    CATEGORY_UTILITY: 'Utilidad',
    CATEGORY_AUTHENTICATION: 'Autenticación',

    ROUTE_LOADING_LABEL: 'Cargando la página',

    SEND_TEST_BUTTON: 'Probar envío',
    SEND_TEST_DISABLED_REASON:
      'Solo se prueban plantillas aprobadas con todas sus variables con dato.',
    SEND_TEST_TITLE: 'Probar envío de WhatsApp',
    SEND_TEST_DESCRIPTION:
      'Envía un mensaje real con send_whatsapp, la misma operación que usan los productos. Cada destinatario recibe el mensaje.',
    SEND_TEST_CLOSE: 'Cerrar',
    SEND_TEST_TEMPLATE_LABEL: 'Plantilla (template_slug)',
    SEND_TEST_TEMPLATE_PLACEHOLDER: 'Elige una plantilla',
    SEND_TEST_TEMPLATE_OPTION: '{{alias}} · {{slug}}',
    SEND_TEST_ORGANIZATION_LABEL:
      'ID de organización (centralized_organization_id)',
    SEND_TEST_VARIABLES_TITLE: 'Variables (variables)',
    SEND_TEST_VARIABLES_CHOOSE_TEMPLATE:
      'Elige una plantilla para ver sus variables.',
    SEND_TEST_VARIABLES_NONE:
      'Esta plantilla no necesita variables del producto.',
    SEND_TEST_VARIABLES_DESCRIPTION: 'Valores para todos los destinatarios.',
    SEND_TEST_VARIABLE_REQUIRED: '{{key}} (obligatoria)',
    SEND_TEST_PROFILE_VARIABLES:
      'Del perfil del destinatario: {{keys}}. El destinatario debe ser miembro de la organización.',
    SEND_TEST_RECIPIENTS_TITLE: 'Destinatarios (recipients)',
    SEND_TEST_RECIPIENT_TITLE: 'Destinatario {{index}}',
    SEND_TEST_RECIPIENT_ADD: 'Agregar destinatario',
    SEND_TEST_RECIPIENT_REMOVE: 'Quitar destinatario {{index}}',
    SEND_TEST_USER_ID_LABEL: 'ID de usuario (centralized_user_id)',
    SEND_TEST_PHONE_LABEL: 'Teléfono (phone)',
    SEND_TEST_PHONE_PLACEHOLDER: '+51987654321',
    SEND_TEST_COUNTRY_LABEL: 'País (country_iso_code)',
    SEND_TEST_COUNTRY_PLACEHOLDER: 'PE',
    SEND_TEST_OVERRIDES_TRIGGER: 'Variables solo para este destinatario',
    SEND_TEST_OVERRIDES_DESCRIPTION:
      'Opcional. Un valor aquí reemplaza el valor común para este destinatario.',
    SEND_TEST_SOURCE_TITLE: 'Origen (source)',
    SEND_TEST_SOURCE_DESCRIPTION:
      'Opcional. Si completas target_type o target_id, completa también app_name.',
    SEND_TEST_APP_NAME_LABEL: 'app_name',
    SEND_TEST_TARGET_TYPE_LABEL: 'target_type',
    SEND_TEST_TARGET_ID_LABEL: 'target_id',
    SEND_TEST_CANCEL: 'Cancelar',
    SEND_TEST_SUBMIT: 'Enviar',
    SEND_TEST_TOAST_TITLE: 'Envío en cola',
    SEND_TEST_TOAST_DESCRIPTION:
      'ID: {{sendId}} · Estado: {{status}} · Destinatarios: {{count}}',
    SEND_TEST_ERROR_TITLE: 'El envío no se hizo',
    SEND_TEST_ERROR_NETWORK: 'No hubo respuesta del servidor.',
    SEND_TEST_ERROR_ISSUE: '{{code}}: {{message}}',
    SEND_TEST_ERROR_ISSUE_FIELD: '{{code}} · {{field}}: {{message}}',
    SEND_TEST_ERROR_REQUIRED: 'Completa este campo.',
    SEND_TEST_ERROR_INTEGER: 'Escribe solo números.',
    SEND_TEST_ERROR_PHONE:
      'Escribe el número con + y el código de país, por ejemplo +51987654321.',
    SEND_TEST_ERROR_RECIPIENTS_MIN: 'Agrega al menos un destinatario.',
    SEND_TEST_ERROR_RECIPIENTS_MAX:
      'Envía a {{max}} destinatarios como máximo.',
    SEND_TEST_ERROR_MAX_LENGTH: 'Escribe {{max}} caracteres como máximo.',
    SEND_TEST_ERROR_APP_NAME_REQUIRED:
      'Completa app_name cuando envías target_type o target_id.',
    SEND_TEST_ERROR_VARIABLE_REQUIRED:
      'Completa este valor aquí o en cada destinatario.',
  },
};
